export class DateComparisonColDef {
  constructor(
    public constant = '',
    public column = '',
    public hasTimeZone = true,
    public selection = 'column', // either column or constant
    public defaultTimezone = 'UTC',
    public defaultFormat = 'yyyy-MM-dd HH:mm:ss',
    public showSigned = false,
  ) {}
}

export class DateComparisonModel {
  constructor(
    public target = '',
    public targetUnit = '',
    public sourceColumn: DateComparisonColDef = new DateComparisonColDef(),
    public compareWith: DateComparisonColDef = new DateComparisonColDef(),
  ) {}
}
